<div class="flex flex-col justify-center items-center mt-4" *transloco="let t; read: 'user.password-change'">
  <h2 class="text-color-sun-yellow">
    {{t('title')}}
  </h2>
  <form class="flex flex-col px-4 w-full md:w-1/2 xl:w-1/4 md:shrink-0" [formGroup]="formGroup"
        (keydown.enter)="changePassword()">


    <div class="opacity-80 text-sm p-2">{{t('register.password_rule', { count: passwordLength })}}</div>
    <psc-input type="password"
               [label]="t('password')"
               formControlName="password"></psc-input>

    <psc-input type="password"
               [label]="t('password_confirm')"
               formControlName="password_confirm"></psc-input>

    <div class="text-red-700"
         *ngIf="formGroup.controls['password_confirm'].errors?.['matchingValues']">{{t('passwords_different')}}</div>

    <psc-button [label]="t('change')"
                (buttonClicked)="changePassword()"
                [disabled]="!formGroup.valid"
                class="my-5"
                type="primary-blue-2"></psc-button>
  </form>
</div>
